/* eslint-disable react/require-default-props,react/destructuring-assignment,consistent-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { autobind } from 'core-decorators';

import TextInput from '../TextInput';
import Icon from '../Icon';
import Button from '../Button';

import { POST_REPLY_PLACEHOLDER } from '../../constants/strings';
import { COLORS } from '../../constants/styles';
import sanitizeHtml from '../../utils/sanitizeHtml';
import convertXMLtoString from '../../utils/convertXMLtoString';
import prettifyText from '../../utils/prettifyText';
import { IDS } from '../../constants/ids';

const REPLY_LIMIT_SIZE = 500;

@injectIntl
export default class Reply extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    initialContent: PropTypes.string,
  };

  textarea = null;

  state = {
    content: '',
  };

  componentWillMount() {
    const { initialContent: content } = this.props;
    const contentText = content && prettifyText(content);
    if (content) {
      this.setState({ content: convertXMLtoString(contentText) });
    }
  }

  componentDidMount() {
    // Handling Ctrl+Enter event to put a line-break into the textarea
    this.textarea.node.addEventListener('keydown', this.handleKeyboardSubmit);
  }

  componentWillUnmount() {
    this.textarea.node.removeEventListener(
      'keydown',
      this.handleKeyboardSubmit,
    );
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault();

    const { content } = this.state;

    this.props.onSubmit(sanitizeHtml(content, true, []));
  }

  @autobind
  handleKeyboardSubmit(e) {
    const enterKey = e.keyCode === 10 || e.keyCode === 13;
    const empty = !this.state.content.trim().length;

    if (enterKey && e.ctrlKey) {
      this.setState({
        content: `${this.textarea.node.value}\n`,
      });
    } else if (enterKey && empty) {
      return e.preventDefault();
    } else if (enterKey && !e.ctrlKey) {
      this.handleSubmit(e);
    }
  }

  render() {
    const { content: value } = this.state;
    const {
      intl: { formatMessage },
    } = this.props;
    const empty = !value.trim().length;

    return (
      <div className="df justify-between">
        <TextInput
          autoresize
          autoFocus
          textarea
          rows="1"
          color="primary"
          limit={REPLY_LIMIT_SIZE}
          ref={node => (this.textarea = node)}
          style={{
            lineHeight: '21px',
            height: 'auto',
            maxHeight: 21 * 4,
            backgroundColor: 'white',
            border: `1px solid ${COLORS.sanMarino}`,
          }}
          wrapperStyle={{
            width: '100%',
            marginRight: '10px',
          }}
          value={value}
          onChange={content => this.setState({ content })}
          rounded
          id={IDS.POST.REPLY_TEXT_AREA}
          placeholder={formatMessage(POST_REPLY_PLACEHOLDER)}
          useNumberHeight
        />
        <Button
          id={IDS.POST.SEND_REPLY_COMMENT_BTN}
          color="primary"
          onClick={this.handleSubmit}
          raised
          disabled={empty}
          style={{ width: '56px', paddingLeft: 0, paddingRight: 0 }}
        >
          <Icon name="send-message" style={{ fill: COLORS.white }} />
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment/Reply.jsx